<template>
  <v-card flat class="mb-5">
    <v-card-text class="px-7">
      <template v-if="isBuka && isTerlaksana">
        <v-row>
          <v-col cols="12" lg="6">
            <div class="body-2">Tanggal Pelaksanaan</div>
            <div class="body-1 black--text">{{ $localDate(laporan.tgl_monev) || '-' }}</div>
          </v-col>
          <v-col cols="12" lg="6">
            <div class="body-2">Moda Penyelenggaraan IHT</div>
            <div class="body-1 black--text">{{ $getDeepObj(laporan, 'm_monev_moda_psp.data.keterangan') || '-' }}</div>
          </v-col>
        </v-row>
        <div class="mt-5" v-if="((laporan && laporan.data_meeting) || []).length">
          <link-rekaman :rekamans="laporan.data_meeting" tipe="row" />
        </div>
        <div class="mt-5">
          <foto-kegiatan :berkases="berkas.foto" tipe="row" />
        </div>
        <div class="mt-5">
          <list-partisipan :partisipans="$getDeepObj(laporan, 'psp_monev_partisipans.data') || []" />
        </div>
      </template>
      <template v-else-if="isBuka && !isTerlaksana">
        <v-row>
          <v-col cols="12" class="text-center">
            <v-icon x-large color="red" style="font-size: 6rem" class="mb-3">mdi-file-alert</v-icon>
            <h2>IHT Tidak Terlaksana</h2>
            <div class="body-2">
              {{ $getDeepObj(laporan, 'm_monev_alasan_psp.data.keterangan') }}
              <span v-if="+laporan.k_monev_alasan_psp === 9">({{ laporan.alasan_lain || '' }})</span>
            </div>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-icon x-large color="grey" style="font-size: 6rem" class="mb-3">mdi-file-alert</v-icon>
            <h2>Laporan IHT Tidak Tersedia</h2>
            <div class="body-2 mt-1">
              Hal ini dikarenakan pihak terkait belum mengirimkan laporannya
            </div>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import FotoKegiatan from '../base/foto';
import LinkRekaman from '../base/rekaman';
import ListPartisipan from '../base/partisipan';

export default {
  name: 'IhtBuka',
  components: { FotoKegiatan, LinkRekaman, ListPartisipan },
  props: {
    laporan: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isBuka() {
      return this.laporan.k_verval_psp > 1;
    },

    isTerlaksana() {
      return +this.laporan.is_terlaksana === 1;
    },

    berkas() {
      const foto = (this.$getDeepObj(this.laporan, 'psp_monev_berkases.data') || []).filter((berkas) =>
        [6].includes(+berkas.k_monev_berkas_psp)
      );

      return {
        foto: foto.map((file) => {
          return file.url_berkas;
        }),
      };
    },

    tautans() {
      return [
        {
          color: 'primary',
          content: [
            '<h2 class="black--text">Tautan Pre Test</h2>',
            '<p class="black--text mt-2">Berikut adalah tautan pre test sesuai UPT perwalian Anda</p>',
          ].join(''),
          contentButton: 'Pre Test',
          link: this.laporan.url_pretest || '',
        },
      ];
    },
  },
};
</script>

<style scoped></style>
